jQuery(document).ready(function($) {
    // Find all links within the comment content
    $('.comment, .post-content, .tips-content-description').find('a').each(function() {
        // Check if the href attribute contains domain name
        if (!$(this).attr('href').includes('oddsnet') && !$(this).hasClass('reply')) {
            // Add rel and target attributes
            $(this).attr('rel', 'noopener nofollow ugc');
            $(this).attr('target', '_blank');
        }
    });
});
